<div class="wrapper text-center" [class.standalone]="standalone">

  <div class="content1">
    <div class="title" translate="home-estimator.your-estimate"></div>

    <div class="address">
      <div>
        {{ homeEstimatorRequest.streetNumber }} {{ homeEstimatorRequest.streetName }}, {{ homeEstimatorRequest.location }},
      </div>
      <div>
        {{ 'provinces.bc' | translate }}
        <b>
          <img style="margin-left: 10px" src="{{'/assets/home-estimator/edit_icon@1x.svg' | staticp}}" alt="{{'home-estimator.edit-address'|translate}}" height="15" width="15">
          <a (click)="onEdit.emit()" translate="home-estimator.edit-address"></a>
        </b>
      </div>
    </div>

    <div class="inner-content">
      <div translate="home-estimator.current-home-value-estimate"></div>
      <div class="graph has-pos-rel">
        <div class="needs-repair has-pos-abs">
          <div class="value">{{ calculatedEstimate.needsRepair | currency:'CAD':'symbol-narrow':'1.0-0' }}</div>
          <div class="text" translate="home-estimator.needs-repair"></div>
        </div>
        <div class="well-maintained has-pos-abs">
          <div class="value">{{ calculatedEstimate.wellMaintained | currency:'CAD':'symbol-narrow':'1.0-0' }}</div>
          <div class="text" translate="home-estimator.well-maintained"></div>
        </div>
        <div class="show-home has-pos-abs">
          <div class="value">{{ calculatedEstimate.showHome | currency:'CAD':'symbol-narrow':'1.0-0' }}</div>
          <div class="text" translate="home-estimator.show-home"></div>
        </div>
        <img src="{{'/assets/home-estimator/graph.svg' | staticp }}" [alt]="'home-estimator.home-values' | translate">
      </div>
      <div class="button-wrapper is-flex has-flex-content-center">
        <button class="btn btn-polar-gradient" (click)="onContactAgent.emit()">
          <span translate="home-estimator.contact-agent"></span>
        </button>
      </div>
    </div>

    <div class="map-wrapper" *ngIf="mapEnabled && screenSize < SCREEN_SIZE.DESKTOP_UP">
      <ngui-map [options]="mapOptions"
                [center]="homeEstimatorRequest.streetNumber + ' ' + homeEstimatorRequest.streetName + ', ' + homeEstimatorRequest.location + ', BC, Canada'"
                (mapReady$)="mapReady($event)"
                (idle)="mapIdle($event)">
        <custom-marker [position]="homeEstimatorRequest.streetNumber + ' ' + homeEstimatorRequest.streetName + ', ' + homeEstimatorRequest.location + ', BC, Canada'">
          <img src="{{'/assets/home-estimator/pin.svg' | staticp }}" >
        </custom-marker>
      </ngui-map>
    </div>

    <hr/>
    <div class="disclaimer" translate="home-estimator.disclaimer"></div>
  </div>

  <div class="content2" *ngIf="mapEnabled && screenSize >= SCREEN_SIZE.DESKTOP_UP">
    <div class="map-wrapper">
      <ngui-map [options]="mapOptions"
                [center]="homeEstimatorRequest.streetNumber + ' ' + homeEstimatorRequest.streetName + ', ' + homeEstimatorRequest.location + ', BC, Canada'"
                (mapReady$)="mapReady($event)"
                (idle)="mapIdle($event)"
      >
        <custom-marker [position]="homeEstimatorRequest.streetNumber + ' ' + homeEstimatorRequest.streetName + ', ' + homeEstimatorRequest.location + ', BC, Canada'">
          <img src="{{'/assets/home-estimator/pin.svg' | staticp }}" >
        </custom-marker>
      </ngui-map>
    </div>
  </div>
</div>

<div class="nearby-listings" [class.standalone]="standalone" *ngIf="standalone && suggestedListings">
  <div class="nearby-listings-title" translate="home-estimator.nearby-listings"></div>
  <app-item-swiper [items]="suggestedListings" [hasFinishedLoadingItems]="suggestedListings.length"></app-item-swiper>
</div>
